import { createDevextremeDatasource } from '@/letapps-vue/utils/useRestApi';

let store;

export function getFaktiskeIndbetalingerDatasource() {
  if (!store) {
    store = createDevextremeDatasource('/api/FaktiskeIndbetalinger', 'id', {
      paginate: false,
    });
  }

  return store;
}
